import { ContentAdd } from '@fs/zion-icon'
import { BleedingCard, Button, colors, H5, Paragraph, Separator } from '@fs/zion-ui'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useCollectionContextProvider } from '../../../../providers/collectionProvider/CollectionProvider'

/**
 * Displays a call-to-action card prompting users to create a new household if they don't see
 * an existing one from the record. Opens the add names overlay with no record ID selected.
 *
 * @component
 * @param {Object} props
 * @param {Function} props.setSelectedRecordId - Callback to set/clear the selected record ID
 * @returns {JSX.Element}
 */
const CreateHouseholdCard = ({ setSelectedRecordId }) => {
  const [t] = useTranslation()
  const { openOverlay } = useOverlayContext()
  const { isReadOnlyCollection } = useCollectionContextProvider()

  const handleAddPersonClick = useCallback(() => {
    setSelectedRecordId(null)
    openOverlay('addNamesOverlay')
  }, [openOverlay, setSelectedRecordId])

  return (
    <>
      <Separator size="xxs" />
      <BleedingCard backgroundColor={colors.blue02} marginY="xxs">
        <H5>{t('create-household-card.title', 'Create household')}</H5>
        <Paragraph size="sm">
          {t(
            'create-household-card.description',
            'Not seeing a household from the record listed here yet? Create one now!'
          )}
        </Paragraph>
        <Separator size="nano" />
        <Button
          emphasis="medium"
          Icon={ContentAdd}
          onClick={handleAddPersonClick}
          linkName="New Household"
          data-testid="new-household-button"
          disabled={isReadOnlyCollection}
          fullWidth
        >
          {t('create-household-card.button', 'New household')}
        </Button>
      </BleedingCard>
      <Separator size="xxs" />
    </>
  )
}

export default CreateHouseholdCard
